<template>
  <div class="freeTrial">
    <div class="title">锐信极致营销 互动触手可及</div>
    <div class="info">Ultimate marketing Interaction at your fingertips</div>
    <button class="btn">
      <a href="https://rms.retouchspace.com" target="_blank">免费体验</a>
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.freeTrial {
  width: 100%;
  height: 400px;
  background-color: #0064ff;
  text-align: center;
  .title {
    font-size: 46px;
    font-family: Alibaba, Alibaba-PuHuiTi;
    font-weight: 600;
    color: #ffffff;
    line-height: 1;
    letter-spacing: 4px;
    padding-top: 102px;
  }
  .info {
    margin-top: 23px;
    line-height: 1;
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
  }
  .btn {
    width: 417px;
    height: 50px;
    background: #ffffff;
    border-radius: 8px;
    border: none;
    margin-top: 60px;
    outline:none;
    cursor: pointer;
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    a {
      text-decoration: none;
      color: rgba(36,46,66,0.8);
      display: block;
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/FreeTrial.vue